import React from 'react'
import { sanitize } from '@utils/sanitize'
import type { DerivedTimespan } from '@features/horizontal_timeline_core/types/derived_items'

interface ClassicTimespanContentProps {
  timespan: DerivedTimespan
}

const TimespanContent: React.FC<ClassicTimespanContentProps> = ({ timespan }) => {
  return (
    <div className="content-holder">
      <div className="content-body">
        <span className="title ellipsify-text" dangerouslySetInnerHTML={{ __html: sanitize(timespan.title) }}></span>
      </div>
    </div>
  )
}

export default TimespanContent
